module.exports = __webpack_public_path__ + "img/light.b6743cf2.jpg";